export default __webpack_public_path__ + "static/media/Eye_6_F_C1.34ae8fab.svg";